import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from './types';

export interface IRequestSerialized {
    headers: Record<string, string>;
    url: string;
    method: string;
    mode: RequestMode | undefined;
    credentials: RequestCredentials | undefined;
    cache: RequestCache;
    redirect: RequestRedirect | undefined;
    referrer: string;
    referrerPolicy: ReferrerPolicy;
    isHistoryNavigation: boolean;
    isReloadNavigation: boolean;
    integrity: string;
    destination: string;
    body: string;
}

export interface IRequestSerializer {
    serialize: (request: Request) => Promise<IRequestSerialized>;
    parse: (request: IRequestSerialized) => Request;
}

export function injectRequestSerializer(
    container: IContainer = injectOrBuildContainer(),
): IRequestSerializer {
    return container.get<IRequestSerializer>(TYPES.IRequestSerializer);
}

export function bindRequestSerializer(
    val: IRequestSerializer,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IRequestSerializer>(TYPES.IRequestSerializer, val);
}

export function unbindRequestSerializer(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IRequestSerializer);
}
